import styled from 'styled-components'
import { heading } from 'styles/typography'
import Button from 'components/button'

export const SectionTitle = styled.h1`
  ${heading.xl};
  max-width: 77rem;
  margin: 0;
`

export const CTAButton = styled(Button as any)`
  margin-top: 5rem;
  display: block;
`
